import { ProductFlashInfoLine } from 'Components/lines/product-flash-info-line/ProductFlashInfoLine';
export default ProductFlashInfoLine;
